"use client";
import { font_title_secularOne } from "@/app/ui/fonts";
import { NavigationMenu, NavigationMenuLink, NavigationMenuList } from "@/app/ui/imported/navigation-menu";
import { cn } from "@/lib/utils";
import AnimatedIcon from "../../ui/utils/AnimatedIcon";

type LinkData = {
    url: string,
    icon?: string,
    alt: string,
    text: string
}

const links: LinkData[] = [
    {
        url: "/",
        text: "ראשי",
        alt: "דף הבית",
        icon: "home"
    },
    {
        url: "/seasons",
        text: "עונות",
        alt: "כל העונות של נייטפול",
        icon: "clip"
    },
    {
        url: "/join",
        text: "טפסים",
        alt: "הצטרפו אלינו לנייטפול",
        icon: "pen"
    },
    {
        url: "/players",
        text: "יוצרים",
        alt: "יוצרי התוכן בשרת",
        icon: "man"
    },
    {
        url: "/qna",
        text: "Q&A",
        alt: "שאלות ותשובות",
        icon: "talk"
    }
]

export default function NavBar() {
    return (
        <NavigationMenu className="dynMenu fit md:min-w-[60%] lg:min-w-[45%] w-[-webkit-fill-available] md:w-auto pb-3 sm:pb-0">
            <NavigationMenuList className="items-stretch flex justify-between flex-col sm:flex-row sm:items-center gap-1">
                {
                    links.map(l => <NavigationMenuLink href={ l.url } key={ l.url } onClick={
                        () => {
                            const menuToggler = document.getElementById("menuToggle");
                            if (menuToggler)
                                (menuToggler as HTMLInputElement).checked = false;
                        }
                    }
                        activeClass="text-nfPurple-400 border-t-2 bg-black/10"
                        className={ cn(font_title_secularOne.className, [`text-nfBlue-300 font-bold rounded px-3 py-1 flex-1 transition-all group relative flex flex-cel gap-1 justify-center hover:bg-white/15 `]) }>
                        { l.icon && <AnimatedIcon fill className="sm:hidden min-[860px]:flex " icon={ l.icon } /> }
                        <span className="group-hover:text-nfPurple-400 group-active:text-white">
                            { l.text }
                        </span>
                    </NavigationMenuLink>)
                }
            </NavigationMenuList>
        </NavigationMenu>
    )
}
